import { request } from "./http";

export const clientInteractionsService = {
  list({ clientId } = {}) {
    const params = new URLSearchParams();
    if (clientId !== undefined && clientId !== null && clientId !== "") {
      params.set("clientId", String(clientId));
    }
    const qs = params.toString();
    return request(`/ClientInteractions${qs ? `?${qs}` : ""}`);
  },

  getById(id) {
    return request(`/ClientInteractions/${id}`);
  },

  create(payload) {
    return request("/ClientInteractions", { method: "POST", body: payload });
  },

  update(id, payload) {
    return request(`/ClientInteractions/${id}`, { method: "PUT", body: payload });
  },

  remove(id) {
    return request(`/ClientInteractions/${id}`, { method: "DELETE" });
  },
};
